import React from 'react';
import CategoryPage from '../components/CategoryPage';
import { comercialProjects } from '../data/mock';
import { Users } from 'lucide-react';

const Comercial = () => (
  <CategoryPage
    icon={Users}
    title="Comercial e Outros"
    subtitle="Registro · Documentação · Eventos. Trabalhos que não cabem nas outras duas gavetas: ações culturais, eventos e projetos autorais."
    projects={comercialProjects}
    tapeColor="rgba(205,175,175,0.42)"
    tapeSide="left"
  />
);

export default Comercial;
